import React, { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import { API_URL } from "../../components/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import AuthContext from "../../context/AuthContext";
import "./DataGridStyles.css";
import axios from "axios";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid";

function DailyDrawerExchange() {
  const [data, setData] = useState([]);
  const [allDrawersData, setAllDrawersData] = useState([]);
  const [toDrawers, setToDrawers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDrawer, setSelectedDrawer] = useState("");
  const [selectedDrawerBalanceUSD, setSelectedDrawerBalanceUSD] = useState(0);
  const [selectedDrawerBalanceLBP, setSelectedDrawerBalanceLBP] = useState(0);
  const [selectedDrawerIDs, setSelectedDrawerIDs] = useState("");
  const [selectedToDrawer, setSelectedToDrawer] = useState("");
  const [selectedToDrawerBalanceUSD, setSelectedToDrawerBalanceUSD] =
    useState(0);
  const [selectedToDrawerBalanceLBP, setSelectedToDrawerBalanceLBP] =
    useState(0);
  const [receipts, setReceipts] = useState([]);
  const [payments, setPayments] = useState([]);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogMessageType, setDialogMessageType] =
    useState("");
  const [receiptDialogOpen, setReceiptDialogOpen] = useState(false); // For the receipts and payments modal
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // Utility to format ISO date to "DD:MM:YYYY HH:mm:ss AM/PM"
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    let hours = date.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 -> 12
    const hh = String(hours).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    const ss = String(date.getSeconds()).padStart(2, "0");
    return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss} ${ampm}`;
  };

  useEffect(() => {
    // Fetching the data of the daily drawers of the user
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/inventory/drawer/daily/fetch/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
            },
          }
        );
        if (response.status === 200) {
          setData(response.data.reverse());
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    // Automatically open the dialog when the component mounts
    setDialogOpen(true);
    fetchAllDailyDrawers();
    fetchTodrawers();
  }, [user.username, authTokens.access]);

  //fetch the merged daily drawer
  //same function as fetchData except employee_id is a extra parameter
  const fetchAllDailyDrawers = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/inventory/drawer/daily/fetch/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            employee_id: user.employee_id,
          },
        }
      );
      if (response.status === 200) {
        setAllDrawersData(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //fetches the drawers of everyone except for the current user
  const fetchTodrawers = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/inventory/drawer/daily/todrawer/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            employee_id: user.employee_id,
          },
        }
      );
      if (response.status === 200) {
        setToDrawers(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //handles the opening of the dialog of the drawer exchange
  const handleOpenDialog = () => {
    fetchAllDailyDrawers();
    fetchTodrawers();
    setDialogOpen(true);
  };

  // handles the closing of the dialog of the drawer exchange and set off the use states
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedDrawer("");
    setSelectedDrawerBalanceUSD(0);
    setSelectedDrawerBalanceLBP(0);
    setSelectedToDrawer("");
    setSelectedToDrawerBalanceUSD(0);
    setSelectedToDrawerBalanceLBP(0);
    setDialogMessage("");
    setDialogMessageType("");
  };

  //handles the selection of daily drawers and its data
  const handleDrawerChange = (event) => {
    const selectedId = event.target.value;
    setSelectedDrawer(selectedId);

    // Find the selected drawer data based on the selectedId
    const selectedDrawerData = allDrawersData.find(
      (drawer) => drawer.daily_drawer_id === selectedId
    );
    if (selectedDrawerData) {
      // Update balances based on selected drawer's data
      setSelectedDrawerBalanceUSD(selectedDrawerData.balance_usd);
      setSelectedDrawerBalanceLBP(selectedDrawerData.balance_lbp);
    } else {
      // Reset balances if no matching drawer is found
      setSelectedDrawerBalanceUSD(0);
      setSelectedDrawerBalanceLBP(0);
    }
  };
  //handles the selection of "to" drawers and its data
  const handleToDrawerChange = (event) => {
    const selectedId = event.target.value;
    setSelectedToDrawer(selectedId);

    const selectedToDrawerData = toDrawers.find(
      (drawer) => drawer.drawer_id === selectedId
    );
    if (selectedToDrawerData) {
      setSelectedToDrawerBalanceUSD(selectedToDrawerData.drawer_balance_usd);
      setSelectedToDrawerBalanceLBP(selectedToDrawerData.drawer_balance_lbp);
    }
  };

  // fetch the data of the selected daily drawer
  const fetchSelectedDrawerData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/inventory/drawer/daily/fetch/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            daily_drawer_id: selectedDrawer,
          },
        }
      );
      if (response.status === 200) {
        console.log("Selected Drawer Data:", response.data);
      }
    } catch (error) {
      console.error("Error fetching selected drawer data:", error);
    }
  };

  // Fetch receipts and payments when opening the modal
  const fetchReceiptsAndPayments = async () => {
    const allReceipts = [];
    const allPayments = [];

    await fetchReceipts(allReceipts);
    await fetchPayments(allPayments);

    setReceipts(allReceipts);
    setPayments(allPayments);
  };

  const fetchReceipts = async (allReceipts) => {
    try {
      const response = await axios.get(
        `${API_URL}/inventory/drawer/daily/transaction/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            daily_drawer_id: selectedDrawer,
            option: "Receipt",
          },
        }
      );
      if (response.status === 200) {
        console.log(response.data);
        allReceipts.push(...response.data); // Push the fetched receipts into allReceipts
      }
    } catch (error) {
      console.error(
        "Error fetching receipts for drawer ID",
        selectedDrawer,
        ":",
        error
      );
    }
  };

  const fetchPayments = async (allPayments) => {
    try {
      const response = await axios.get(
        `${API_URL}/inventory/drawer/daily/transaction/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            daily_drawer_id: selectedDrawer,
            option: "Payment",
          },
        }
      );
      if (response.status === 200) {
        console.log(response.data);
        allPayments.push(...response.data); // Push the fetched payments into allPayments
      }
    } catch (error) {
      console.error(
        "Error fetching payments for drawer ID",
        selectedDrawer,
        ":",
        error
      );
    }
  };

  // send the selected daily drawer alongside its data consisting of receipts , payments and balances to one of the selected drawers
  const sendDailyDrawer = async () => {
    const response = await axios.post(
      `${API_URL}/inventory/drawer/daily/transaction/`,
      {
        toDrawer: selectedToDrawer,
        daily_drawer_id: selectedDrawer,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    );

    return response.data;
  };

  // Handle opening of receipts and payments modal
  const handleOpenReceiptsModal = async () => {
    await fetchReceiptsAndPayments();
    setReceiptDialogOpen(true);
  };

  // Close receipts and payments modal
  const handleCloseReceiptsModal = () => {
    setReceiptDialogOpen(false);
    setReceipts([]);
    setPayments([]);
  };

  // handles the follows axios when pressing on the transfer button in the drawer exchange dialog
  const handleSend = async () => {
    if (isButtonDisabled) {
      return;
    }

    if (!selectedDrawer || !selectedToDrawer) {
      setDialogMessage(
        "Select both a daily drawer and a destination drawer."
      );
      setDialogMessageType("error");
      return;
    }

    setIsButtonDisabled(true);
    setDialogMessage("");
    setDialogMessageType("");

    try {
      const responseData = await sendDailyDrawer();

      setDialogMessage(
        responseData?.message ||
          "Transfer request sent for approval."
      );
      setDialogMessageType("success");

      setSelectedDrawer("");
      setSelectedDrawerBalanceUSD(0);
      setSelectedDrawerBalanceLBP(0);
      setSelectedToDrawer("");
      setSelectedToDrawerBalanceUSD(0);
      setSelectedToDrawerBalanceLBP(0);
      setReceipts([]);
      setPayments([]);

      await fetchAllDailyDrawers();
    } catch (error) {
      console.error(
        "Error creating transfer request:",
        error
      );

      setDialogMessage(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "The transfer request could not be created."
      );
      setDialogMessageType("error");
    } finally {
      setIsButtonDisabled(false);
    }
  };

  return (
    <div>
      <Form style={{ padding: "10px" }}>
        <h3>Select a Drawer</h3>
        {/* Displays the message whether the daily drawer exchange is successful or not */}
        {dialogMessage && (
          <div
            style={{
              marginBottom: "10px",
              color:
                dialogMessageType === "success"
                  ? "green"
                  : "red",
            }}
          >
            {dialogMessage}
          </div>
        )}

        <Form.Group controlId="dailyDrawerSelect">
          <Form.Label>Daily Drawer</Form.Label>
          {/* Handles the daily drawer selection of the current user */}
          <Select
            labelId="daily-drawer-select-label"
            id="daily-drawer-select"
            value={selectedDrawer}
            onChange={handleDrawerChange}
            fullWidth
          >
            {allDrawersData.map((drawer) => (
              <MenuItem
                key={drawer.daily_drawer_id}
                value={drawer.daily_drawer_id}
              >
                {drawer.name} / {formatDateTime(drawer.date)}
              </MenuItem>
            ))}
          </Select>
        </Form.Group>

        <Button
          variant="primary"
          onClick={handleOpenReceiptsModal}
          style={{
            marginTop: "10px",
            backgroundColor: "#5C636A",
            color: "white",
          }}
        >
          Show Receipts & Payments
        </Button>

        {/* Read-only USD and LBP input */}
        <Form.Group style={{ marginTop: "10px" }}>
          <Form.Label>USD</Form.Label>
          <Form.Control
            type="text"
            value={selectedDrawerBalanceUSD}
            readOnly
            placeholder="Balance USD"
          />
        </Form.Group>

        <Form.Group style={{ marginTop: "10px" }}>
          <Form.Label>LBP</Form.Label>
          <Form.Control
            type="text"
            value={selectedDrawerBalanceLBP}
            readOnly
            placeholder="Balance LBP"
          />
        </Form.Group>

        {/* Handles the drawer selection */}
        <Form.Group controlId="toDrawerSelect" style={{ marginTop: "20px" }}>
          <Form.Label>To Drawers</Form.Label>
          <Select
            labelId="to-drawer-select-label"
            id="to-drawer-select"
            value={selectedToDrawer}
            onChange={handleToDrawerChange}
            fullWidth
          >
            {toDrawers.map((drawer) => (
              <MenuItem key={drawer.drawer_id} value={drawer.drawer_id}>
                {drawer.drawer_name}
              </MenuItem>
            ))}
          </Select>
        </Form.Group>

        {/* Read-only USD and LBP input */}
        <Form.Group style={{ marginTop: "10px" }}>
          <Form.Label>USD</Form.Label>
          <Form.Control
            type="text"
            value={selectedToDrawerBalanceUSD}
            readOnly
            placeholder="To Drawer USD"
          />
        </Form.Group>

        <Form.Group style={{ marginTop: "10px" }}>
          <Form.Label>LBP</Form.Label>
          <Form.Control
            type="text"
            value={selectedToDrawerBalanceLBP}
            readOnly
            placeholder="To Drawer LBP"
          />
        </Form.Group>
        <Button
          variant="primary"
          onClick={handleSend}
          style={{
            backgroundColor: isButtonDisabled
              ? "grey"
              : "#0056B3",
            color: "white",
            marginTop: "10px",
          }}
          disabled={
            isButtonDisabled ||
            !selectedDrawer ||
            !selectedToDrawer
          }
        >
          {isButtonDisabled
            ? "Sending..."
            : "Transfer"}
        </Button>
        {/* Keep the Receipts and Payments Dialog as it is */}
        <Dialog
          open={receiptDialogOpen}
          onClose={handleCloseReceiptsModal}
          maxWidth="lg"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              width: "800px",
              maxWidth: "800px",
            },
          }}
        >
          <DialogTitle>Receipts and Payments</DialogTitle>
          <DialogContent>
            <div style={{ height: 400, width: "100%" }}>
              <h5>Receipts</h5>
              <DataGrid
                rows={receipts}
                columns={[
                  { field: "receipt_id", headerName: "ID", width: 90 },
                  {
                    field: "description",
                    headerName: "Description",
                    width: 300,
                  },
                  {
                    field: "balance_usd",
                    headerName: "Balance USD",
                    width: 150,
                  },
                  {
                    field: "balance_lbp",
                    headerName: "Balance LBP",
                    width: 220,
                  },
                ]}
                pageSize={5}
                rowsPerPageOptions={[5]}
                getRowId={(row) => row.receipt_id}
                className="custom-data-grid"
              />
              <h5>Payments</h5>
              <DataGrid
                rows={payments}
                columns={[
                  { field: "payment_id", headerName: "ID", width: 90 },
                  {
                    field: "description",
                    headerName: "Description",
                    width: 300,
                  },
                  {
                    field: "balance_usd",
                    headerName: "Balance USD",
                    width: 150,
                  },
                  {
                    field: "balance_lbp",
                    headerName: "Balance LBP",
                    width: 220,
                  },
                ]}
                pageSize={5}
                rowsPerPageOptions={[5]}
                getRowId={(row) => row.payment_id}
                className="custom-data-grid"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseReceiptsModal}>Close</Button>
          </DialogActions>
        </Dialog>
      </Form>
    </div>
  );
}

export default DailyDrawerExchange;
